"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _DayPicker = _interopRequireDefault(require("react-day-picker/DayPicker"));

require("./styles.css");

var _lib = require("../../lib");

var _ = _interopRequireDefault(require("./"));

var _NavBar = _interopRequireDefault(require("./NavBar"));

var _common = require("../../common");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DatePickerCalendar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DatePickerCalendar, _PureComponent);

  function DatePickerCalendar(props) {
    var _this;

    _classCallCheck(this, DatePickerCalendar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePickerCalendar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (day, modifiers, e) {
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (day) {
        // check if really has valid day only setState
        _this.setState({
          value: day,
          displayDate: day
        }, function () {
          var format = _this.props.format; // if no format provided, return Date object

          var value = day;

          if (format || (0, _lib.isString)(format)) {
            value = (0, _moment["default"])(day).format(format);
          }

          if (onChange) {
            onChange(e, {
              name: name,
              value: value
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthChange", function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var displayDate = _this.state.displayDate;

      if (name === 'month' && value) {
        _this.setState({
          displayDate: new Date(displayDate.getFullYear(), value)
        });
      }

      if (name === 'year' && value) {
        _this.setState({
          displayDate: new Date(value, displayDate.getMonth())
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthPrevious", function () {
      var displayDate = _this.state.displayDate;

      _this.setState({
        displayDate: new Date(displayDate.getFullYear(), displayDate.getMonth() - 1)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMonthNext", function () {
      var displayDate = _this.state.displayDate;

      _this.setState({
        displayDate: new Date(displayDate.getFullYear(), displayDate.getMonth() + 1)
      });
    });

    var _value = props.value,
        _displayDate = props.displayDate;

    var newValue = _["default"].getDateObj(_value);

    _this.state = {
      prevProps: {
        value: _value,
        displayDate: _displayDate
      },
      value: newValue,
      displayDate: newValue || _displayDate
    };
    return _this;
  }

  _createClass(DatePickerCalendar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabledDays = _this$props2.disabledDays,
          selectedDays = _this$props2.selectedDays;
      var _this$state = this.state,
          value = _this$state.value,
          displayDate = _this$state.displayDate;

      var disabledDates = _["default"].bulkConvert(disabledDays);

      var selectedDates = _["default"].bulkConvert(selectedDays);

      return _react["default"].createElement(_DayPicker["default"], {
        selectedDays: value || null,
        month: displayDate,
        initialMonth: value || new Date(),
        navbarElement: _react["default"].createElement(_NavBar["default"], _extends({}, this.props, this.state, {
          onChange: this.handleOnMonthChange,
          onNext: this.handleOnMonthNext,
          onPrevious: this.handleOnMonthPrevious
        })),
        onDayClick: this.handleOnChange,
        disabledDays: disabledDates,
        modifiers: {
          highlighted: selectedDates
        }
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          displayDate = props.displayDate;

      var newValue = _["default"].getDateObj(value);

      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          displayDate: displayDate
        },
        value: prevProps.value !== value ? newValue : state.value,
        displayDate: prevProps.displayDate !== displayDate ? newValue : state.displayDate
      };
    }
  }]);

  return DatePickerCalendar;
}(_react.PureComponent);

exports["default"] = DatePickerCalendar;

_defineProperty(DatePickerCalendar, "className", 'MHub-DatePicker-Calendar');

_defineProperty(DatePickerCalendar, "propTypes", {
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  selectedDays: _propTypes["default"].shape({
    from: _common.customPropTypes.moment,
    to: _common.customPropTypes.moment
  }),
  disabledDays: _propTypes["default"].oneOfType([_common.customPropTypes.moment, _propTypes["default"].arrayOf(_common.customPropTypes.moment)]),
  displayDate: _common.customPropTypes.moment,
  yearsLimit: _propTypes["default"].number,
  format: _propTypes["default"].string
});

_defineProperty(DatePickerCalendar, "defaultProps", {
  name: null,
  value: null,
  onChange: null,
  selectedDays: null,
  disabledDays: null,
  displayDate: new Date(),
  yearsLimit: 50,
  format: null
});